import React, { useState, useEffect } from 'react';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

const WHATSAPP_NUMBER = '263772813788'; // Format: country code + number without + or 0

export default function FloatingButtons(): React.ReactElement {
  const [showBackToTop, setShowBackToTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowBackToTop(window.scrollY > 300);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleBackToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleWhatsAppClick = () => {
    const message = encodeURIComponent('Hello, I would like to inquire about your engineering services.');
    const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${message}`;
    window.open(whatsappUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <>
      {/* WhatsApp Floating Button - Always fixed at bottom */}
      <button
        onClick={handleWhatsAppClick}
        className="fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg transition-all duration-300 hover:scale-110 hover:shadow-xl sm:h-16 sm:w-16"
        aria-label="Contact us on WhatsApp"
        title="Contact us on WhatsApp"
      >
        <WhatsAppIcon fontSize="large" />
      </button>

      {/* Back to Top Button - Positioned above WhatsApp */}
      {showBackToTop && (
        <button
          onClick={handleBackToTop}
          className="fixed right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-sky-600 text-white shadow-lg transition-all duration-300 hover:scale-110 hover:bg-sky-700 hover:shadow-xl sm:h-16 sm:w-16 bottom-24 sm:bottom-28"
          aria-label="Back to top"
          title="Back to top"
        >
          <KeyboardArrowUpIcon fontSize="large" />
        </button>
      )}
    </>
  );
}

